import { render, staticRenderFns } from "./ReserveConfirmation.vue?vue&type=template&id=071fbb40"
import script from "./ReserveConfirmation.vue?vue&type=script&lang=js"
export * from "./ReserveConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports